import * as React from 'react';
import { BugIcon, LayoutDashboardIcon } from 'lucide-react';

import { useAuth } from '@/lib/auth/AuthContext';
import { ReportIssueDialog } from '@/components/ReportIssueDialog';
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';

export function NavActions() {
  const [isReportIssueOpen, setIsReportIssueOpen] = React.useState(false);
  const { user } = useAuth();

  return (
    <>
      <SidebarGroup>
        <SidebarGroupContent>
          <SidebarMenu>
            {user?.is_superuser && (
              <SidebarMenuItem>
                <SidebarMenuButton asChild tooltip="Admin Dashboard">
                  <a href="/admin" target="_blank" rel="noopener noreferrer">
                    <LayoutDashboardIcon />
                    <span>Admin Dashboard</span>
                  </a>
                </SidebarMenuButton>
              </SidebarMenuItem>
            )}
            <SidebarMenuItem>
              <SidebarMenuButton tooltip="Report an issue" onClick={() => setIsReportIssueOpen(true)}>
                <BugIcon />
                <span>Report an issue</span>
              </SidebarMenuButton>
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>

      <ReportIssueDialog open={isReportIssueOpen} onOpenChange={setIsReportIssueOpen} />
    </>
  );
}
